@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.supplies-card-container {
  width: 100%;
  max-width: 1000px;
  gap: @space-24;
  border-radius: 8px;
  border: 1px solid var(--grey-300);
  background: var(--grey-000);
  padding: @space-16;
}

.header {
  gap: @space-8;
  text-align: left;
}

.title.title {
  color: var(--grey-900);
  margin: 0;
}

.subtext {
  color: var(--grey-900);

  a {
    color: var(--blue-600);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.cards-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  width: 100%;
  gap: @space-16;

  @media @mobile {
    gap: @space-12;
  }

  @media @tablet {
    gap: @space-16;
  }
}
